import React, { useEffect, useState, useMemo } from "react";
import Helmet from "../../components/Helmet";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { CategoryFormValidation } from "../../components/LoginValidation";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../api/axiosInstance";
import { useNavigate } from "react-router-dom";

const DiscrepencyStudent = () => {
  const [loading, setLoading] = useState(false);
  const [totalStudents, setTotalStudents] = useState([]);
  const [totalRecords, setTotalRecords] = useState([]);
  const [totalPages, setTotalPages] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [newCategory, setNewCategory] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;
  const [errors, setErrors] = useState({});
  const navigate=useNavigate();
  const handleExport = async () => {
    try {
      setLoading(true);

      const res = await api.get("/admin/discrepencyStudents", {
        params: {
          search,
          export: true,
        },
      });

      const { columns, data } = res.data;

      if (!data || data.length === 0) {
        toast.warning("No data to export");
        return;
      }

      const headerRow = columns.map((c) => c.label).join(",");

      const csvRows = [
        headerRow,
        ...data.map((row) =>
          columns.map((col) => `"${row[col.key] ?? ""}"`).join(","),
        ),
      ];

      const csvContent = csvRows.join("\n");

      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `discrepency_students_${Date.now()}.csv`;
      link.click();

      window.URL.revokeObjectURL(url);
      toast.success("Export Successfull");
    } catch (err) {
      console.error(err);
      toast.error("Export failed");
    } finally {
      setLoading(false);
    }
  };

  const handleView=(sol_roll_no)=>{
    navigate(`discrepancyView/${sol_roll_no}`);
  };

  const fetchTotalStudents = async () => {
    try {
      setLoading(true);

      const res = await api.get("/admin/discrepencyStudents", {
        params: { page, search },
      });

      setTotalStudents(res.data.data || []);
      setTotalRecords(res.data.totalRecords);
      setTotalPages(res.data.totalPages);

      setTotalStudents(res.data.data || []);

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTotalStudents();
  }, [page]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
      fetchTotalStudents();
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  return (
    <>
      <Helmet title={`Discrepency Students`} />
      <ToastContainer position="top-center" autoClose={3000} />
      {loading && (
        <div className="full-page-loader">
          <ClipLoader size={60} />
        </div>
      )}

      <main className="app-main">
        <div className="app-content m-2">
          <div className="container-fluid">
            <div className="card mb-4">
              <div className="card-body">
                <div
                  className="d-flex justify-content-between mb-3"
                  style={{ float: "inline-end" }}
                >
                  <button
                    type="button"
                    className="btn btn-success pull-right"
                    onClick={handleExport}
                    disabled={loading}
                  >
                    {loading ? "Exporting..." : "Export"}
                  </button>
                </div>

                <div className="d-flex justify-content-between mb-3">
                  <input
                    type="text"
                    className="form-control w-25"
                    placeholder="Search by Name / Roll / Mobile... "
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>

                <table className="table table-bordered">
                  <thead className="table-dark">
                    <tr>
                      <th style={{ width: "60px" }}>S.NO</th>
                      <th>SOL ROLL NO.</th>
                      <th>STUDENT NAME</th>
                      <th>PROGRAMME</th>
                      <th>SEMESTER</th>
                      <th>MOBILE</th>
                      <th style={{ width: "150px" }}>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {totalStudents.length > 0 ? (
                      totalStudents.map((student, index) => (
                        <tr key={student.id}>
                          <td>{(page - 1) * pageSize + (index + 1)}</td>
                          <td>{student.SOL_ROLL_NO}</td>
                          <td>{student.STUDENT_NAME}</td>
                          <td>{student.COURSE}</td>
                          <td>{student.SEMESTER}</td>
                          <td>{student.MOBILE}</td>
                          <td>
                            <button
                              onClick={() =>
                                handleView(student.SOL_ROLL_NO)
                              }
                              className="btn btn-warning btn-sm"
                              target="_blank"
                            >
                              View
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} className="text-center">
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <br />

                {/* 📌 Pagination */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <span>
                    Showing {(page - 1) * 50 + 1} to{" "}
                    {(page - 1) * 50 + totalStudents.length} of {totalRecords}
                  </span>

                  <div>
                    <button
                      className="btn btn-secondary btn-sm me-2"
                      disabled={page === 1}
                      onClick={() => setPage(page - 1)}
                    >
                      Prev
                    </button>

                    <button
                      className="btn btn-secondary btn-sm"
                      disabled={page === totalPages || totalPages === 0}
                      onClick={() => setPage(page + 1)}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ADD CATEGORY MODAL */}
        <div className="modal fade" id="addCategoryModal" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New Category</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                ></button>
              </div>

              <div className="modal-body">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter category name"
                  name="category_name"
                  value={newCategory}
                  onChange={(e) => setNewCategory(e.target.value)}
                />
                {errors.category_name && (
                  <small className="text-danger">{errors.category_name}</small>
                )}
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button className="btn btn-primary">Save</button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default DiscrepencyStudent;
